module.exports = __webpack_public_path__ + "assets/shengdanjie.dd40f8ff.svg";